import React from "react";
import { Box, Stack } from "@mui/material";
import { ColorSystemProps } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";

const { baseUrl } = parlorRegion;

const SIDOS = [
  {
    code: "22",
    name: "대구",
    tag: "광역시",
    desc: "달서구·북구 등 도심 장례식장 집중",
  },
  {
    code: "37",
    name: "경북",
    tag: "도",
    desc: "포항·경주·구미·안동 등 광역 커버",
  },
];

export function SidoNav({
  currentSidoCode,
  mainColor,
}: {
  currentSidoCode: string;
  mainColor: ColorSystemProps;
}) {
  return (
    <Stack padding="40px 20px 56px">
      <Box
        component="h2"
        style={{
          fontSize: "24px",
          fontWeight: 700,
          color: "#252525",
        }}
      >
        대구·경북 장례식장 안내
      </Box>
      <Box
        component="p"
        style={{
          marginTop: "14px",
          fontSize: "16px",
          lineHeight: 1.75,
          color: "#535353",
          maxWidth: "720px",
        }}
      >
        대구경북 장례식장 위치·빈소·비용을 지역별로 확인하세요.
      </Box>
      <Box
        style={{
          marginTop: "28px",
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: "14px",
        }}
      >
        {SIDOS.map((sido) => {
          const isCurrent = currentSidoCode === sido.code;
          return (
            <Box
              key={sido.code}
              component="a"
              href={`${baseUrl}/price/${sido.code}/`}
              style={{
                background: isCurrent ? mainColor.c100 : "#fff",
                border: `1px solid ${isCurrent ? mainColor.c400 : "#e9e9e9"}`,
                borderRadius: "12px",
                padding: "20px 18px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                textDecoration: "none",
                transition: "border-color .15s, background .15s",
              }}
            >
              <Box
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: mainColor.c500,
                  letterSpacing: "0.04em",
                }}
              >
                {sido.tag}
                {isCurrent ? " · 현재 지역" : ""}
              </Box>
              <Box
                style={{
                  fontSize: "17px",
                  fontWeight: 700,
                  color: "#252525",
                  marginTop: "2px",
                }}
              >
                {sido.name}
              </Box>
              <Box
                style={{
                  fontSize: "12px",
                  color: "#686868",
                  marginTop: "4px",
                  lineHeight: 1.55,
                }}
              >
                {sido.desc}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Stack>
  );
}
